import type { Action } from '@forms/types/context-action/action';
import type { MetadataTemplate, MetadataField } from '@forms/types/Metadata';
import type { IntlShape } from 'react-intl';
import type { FormContent } from '@forms/types/form/Form';
import type { Mode } from '../../builder-type';

export const ADD_REMOVE_FIELD_ACTIONS = {
  ADD_CHECKBOX_FIELD: 'ADD_CHECKBOX_FIELD',
  ADD_DESCRIPTION_FIELD: 'ADD_DESCRIPTION_FIELD',
  ADD_EMAIL_FIELD: 'ADD_EMAIL_FIELD',
  ADD_METADATA_FIELD: 'ADD_METADATA_FIELD',
  ADD_RADIO_FIELD: 'ADD_RADIO_FIELD',
  ADD_UPLOAD_FIELD: 'ADD_UPLOAD_FIELD',
  ADD_UPLOAD_FIELD_TO_METADATA_FIELD: 'ADD_UPLOAD_FIELD_TO_METADATA_FIELD',
  UPDATE_CONTENT: 'UPDATE_CONTENT',
  REMOVE_FIELD: 'REMOVE_FIELD',
  REMOVE_UPLOAD_FIELD_FROM_METADATA_FIELD:
    'REMOVE_UPLOAD_FIELD_FROM_METADATA_FIELD',
} as const;

export type AddCheckboxFieldAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.ADD_CHECKBOX_FIELD
>;
export type AddDescriptionFieldAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.ADD_DESCRIPTION_FIELD,
  { intl?: IntlShape }
>;
export type AddEmailFieldAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.ADD_EMAIL_FIELD,
  { intl: IntlShape }
>;
export type AddMetadataFieldAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.ADD_METADATA_FIELD,
  {
    newMetadataTemplate?: MetadataTemplate;
    metadataField?: MetadataField;
    metadataTemplateId?: string;
  }
>;
export type AddRadioFieldAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.ADD_RADIO_FIELD
>;
export type AddUploadFieldAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.ADD_UPLOAD_FIELD,
  { intl?: IntlShape; mode?: Mode }
>;
export type AddUploadFieldToMetadataFieldAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.ADD_UPLOAD_FIELD_TO_METADATA_FIELD,
  {
    fieldId: string;
    uploadFieldId: string;
  }
>;

export type UpdateContentAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.UPDATE_CONTENT,
  {
    formContent: FormContent;
  }
>;

export type RemoveFieldAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.REMOVE_FIELD,
  {
    id?: string;
    intl?: IntlShape;
    multipleMetadataTemplatesEnabled?: boolean;
    formContent?: FormContent;
    newMetadataTemplates?: MetadataTemplate[];
  }
>;

export type RemoveUploadFieldFromMetadataFieldAction = Action<
  typeof ADD_REMOVE_FIELD_ACTIONS.REMOVE_UPLOAD_FIELD_FROM_METADATA_FIELD,
  {
    fieldId: string;
    uploadFieldId: string;
  }
>;

export type AddRemoveFieldReducerActions =
  | AddUploadFieldToMetadataFieldAction
  | UpdateContentAction
  | RemoveUploadFieldFromMetadataFieldAction;

export type AddRemoveFieldHandlerActions =
  | AddCheckboxFieldAction
  | AddDescriptionFieldAction
  | AddEmailFieldAction
  | AddMetadataFieldAction
  | AddRadioFieldAction
  | AddUploadFieldAction
  | RemoveFieldAction;

export type AddRemoveFieldActions =
  | AddRemoveFieldReducerActions
  | AddRemoveFieldHandlerActions;
